import { Link, useNavigate } from 'react-router-dom';
import { banners, categories, comics, siteInfo } from '@/mocks/comics';
import { useEffect, useRef, useState } from 'react';

export default function Banner() {
  const [current, setCurrent] = useState(0);
  const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null);
  const navigate = useNavigate();

  useEffect(() => {
    intervalRef.current = setInterval(() => {
      setCurrent((prev) => (prev + 1) % banners.length);
    }, 5000);
    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, []);

  const goTo = (index: number) => {
    setCurrent(index);
    if (intervalRef.current) clearInterval(intervalRef.current);
    intervalRef.current = setInterval(() => {
      setCurrent((prev) => (prev + 1) % banners.length);
    }, 5000);
  };

  const banner = banners[current];

  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      {banners.map((b, i) => (
        <div
          key={b.id}
          className={`absolute inset-0 transition-opacity duration-700 ${
            i === current ? 'opacity-100' : 'opacity-0'
          }`}
        >
          <img
            src={b.cover}
            alt={b.title}
            className="w-full h-full object-cover"
          />
        </div>
      ))}
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/60"></div>

      <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-4 w-full">
        <div className="max-w-3xl mx-auto">
          <span className="inline-block px-3 py-1 text-xs font-medium bg-primary-500 text-background-50 rounded-full mb-4">
            {banner.tag}
          </span>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-white mb-4 leading-tight">
            {banner.title}
          </h2>
          <button
            onClick={() => { navigate(`/comic/${banner.comicId}`); window.scrollTo(0, 0); }}
            className="px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium rounded-full transition-all cursor-pointer whitespace-nowrap"
          >
            立即阅读
            <i className="ri-arrow-right-line ml-2"></i>
          </button>
        </div>
      </div>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 flex items-center gap-2">
        {banners.map((_, i) => (
          <button
            key={i}
            onClick={() => goTo(i)}
            className={`w-2 h-2 rounded-full transition-all cursor-pointer ${
              i === current ? 'bg-primary-500 w-6' : 'bg-white/60 hover:bg-white/80'
            }`}
            aria-label={`切换到第${i + 1}张横幅`}
          ></button>
        ))}
      </div>
    </section>
  );
}